import React from 'react'

function MissingPage() {
    return (
        <div>404</div>
    )
}

export default MissingPage